// extracted by mini-css-extract-plugin
export var centerText = "_99-8";
export var container = "_99-0";
export var doughnutContainer = "_99-7";
export var legend = "_99-a";
export var legendItemColorDisplay = "_99-b";
export var legendItemLabel = "_99-d";
export var legendItemValue = "_99-c";
export var lg = "_99-5";
export var maxWidth = "_99-9";
export var md = "_99-4";
export var responsive = "_99-6";
export var sm = "_99-3";
export var xs = "_99-2";
export var xxs = "_99-1";